import React, { useEffect, useRef, useState } from "react";
import { http } from "@/lib/api";

export default function DockStamps() {
  const [items, setItems] = useState([]);
  const dockRef = useRef(null);
  const [cursorX, setCursorX] = useState(null);
  const [width, setWidth] = useState(0);
  const [activeIdx, setActiveIdx] = useState(null);

  useEffect(() => {
    http.get("/testimonials").then(({ data }) => setItems((data.testimonials || []).slice(0, 12))).catch(() => {});
  }, []);

  useEffect(() => {
    const el = dockRef.current;
    if (!el) return;
    const measure = () => setWidth(el.getBoundingClientRect().width);
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, [items.length]);

  const onMove = (e) => {
    const el = dockRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    setCursorX(e.clientX - rect.left);
  };
  const onLeave = () => { setCursorX(null); setActiveIdx(null); };

  const count = items.length;
  const step = count ? width / count : 0;

  if (!count) return null;

  return (
    <div className="relative py-16 overflow-visible">
      <div className="text-center mb-6 px-6">
        <span className="text-xs uppercase tracking-[0.3em] text-[#C9A961] font-semibold">Passport wall</span>
        <h3 className="font-serif text-2xl sm:text-3xl mt-2 text-app">
          <em className="text-[#C9A961]">Twelve more</em> stamps this month.
        </h3>
        <p className="text-xs text-app-muted mt-2">Move your cursor across the dock — hover a stamp to read the story.</p>
      </div>

      <div
        ref={dockRef}
        data-testid="stamp-dock"
        onMouseMove={onMove}
        onMouseLeave={onLeave}
        className="relative h-[240px] mx-auto max-w-6xl flex items-end justify-center gap-1 px-8"
      >
        {items.map((s, i) => {
          const stampCenter = step * (i + 0.5);
          const mid = count / 2 - 0.5;
          const idxDist = Math.abs(i - mid) / (mid || 1);
          const baseScale = 0.55 + (1 - idxDist * idxDist) * 0.55;
          const edgeOpacity = Math.max(0, 1 - Math.pow(idxDist, 2.6) * 1.35);
          let mouseBoost = 0;
          if (cursorX != null) {
            const dx = Math.abs(stampCenter - cursorX);
            const spread = step * 2.2;
            mouseBoost = Math.max(0, 1 - dx / spread) * 0.9;
          }
          const scale = baseScale + mouseBoost;
          const isActive = activeIdx === i;
          return (
            <div
              key={s.id || s.name}
              data-testid={`dock-stamp-${i}`}
              className="dock-item"
              style={{ transform: `scale(${scale})`, opacity: edgeOpacity, zIndex: isActive ? 40 : Math.round(scale * 10) }}
              onMouseEnter={() => setActiveIdx(i)}
              onMouseLeave={() => setActiveIdx((cur) => (cur === i ? null : cur))}
            >
              <div className="dock-stamp">
                <img src={s.img} alt={s.name} loading="lazy" />
                <span className="dock-flag">{s.flag}</span>
              </div>
              {isActive && (
                <div className="dock-story" role="tooltip">
                  <div className="dock-story-name">{s.name}</div>
                  <div className="dock-story-meta">{s.role} · {s.city}</div>
                  <div className="dock-story-quote">"{s.quote}"</div>
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div className="dock-fade dock-fade-left" />
      <div className="dock-fade dock-fade-right" />
    </div>
  );
}
